// Components
import Toolbar from "./Toolbar";
import ToolbarIcon from "./ToolbarIcon";
import ToolbarSubtitle from "./ToolbarSubtitle";

// Utilities
import { createSimpleFunctional } from "@utils/helpers";

const ToolbarItems = createSimpleFunctional("toolbar__items");

export { Toolbar, ToolbarIcon, ToolbarItems, ToolbarSubtitle };

export default {
  $_subcomponents: {
    Toolbar,
    ToolbarIcon,
    ToolbarItems
  }
};
